import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import SetOperatorSelect from '../../wizard/filter-meta/set-operator-select'
import template from './principal-filter.hbs'
import i18n from 'scoreboard/components/i18n'

var PrincipalFilter = Backbone.View.extend({

	className: 'report-filters principal-filter',

	events: {
		'change [name=anyPrincipals]': 'changeAnyPrincipals'
	},

	initialize: function(options = {}) {
		let url = `api/organizations/${options.orgId}/potential-assignees`
		// #43907 if we are filtering for the mass edit selections, use
		// the MassEditController endpoint to retrieve all potential assignees
		// (instead of for only one specific organization)
		if (options.massEdit) {
			url = 'api/admin/mass-edit/potential-assignees'
		}
		if (options.assigneeType == 'owners') {
			url += '?' + $.param({includeViewOnly: false, includeActiveViewers: true})
		}
		this.principalsPanel = new PrincipalPanel({
			url,
			headingKey: options.assigneesInfo.heading,
			placeholderKey: options.assigneesInfo.placeholder,
			currentPrincipals: options.data.values
		})
		this.setOperator = new SetOperatorSelect(options)

		this.data = _.assign({
			values: [],
			anyValueLabelCode: 'common.user.anyUserOrGroup'
		}, options.data)

		this.selectionMap = _.keyBy(options.seedData || [], function(o) {
			return o.id + '-' + o.type
		})

		this.listenTo(this.principalsPanel, 'change', this.trigger.bind(this, 'change'))
	},

	render: function() {
		this.$el.html(template())
		this.$('.principal-selection')
			.html(this.setOperator.render().el)
			.append(this.principalsPanel.render().el)

		let anyValue = !!this.data.anyValue
		this.$('input[name="anyPrincipals"][value="'+anyValue+'"]').prop('checked', true)
		this.$('.specific-user-group-panel').toggleClass('is-not-displayed', anyValue)

		return this
	},

	changeAnyPrincipals: function(e) {
		let anyPrincipals = this.$(e.currentTarget).val()
		this.data.anyValue = anyPrincipals
		this.$('.specific-user-group-panel').toggleClass('is-not-displayed', anyPrincipals)
		this.trigger('change')
	},

	gather: function(e) {
		let anyPrincipals = this.$('input[name=anyPrincipals][value="true"]').prop('checked')
		this.data.anyValue = anyPrincipals
		this.data.values = []
		if (!anyPrincipals) {
			_.forEach(this.principalsPanel.getPrincipals(), function(assignee, i) {
				var data = _.assign(assignee, this.selectionMap[assignee.id + '-' + assignee.type])
				data.updateThresholds = assignee.updateThresholds || false
				this.data.values.push(data)
			}.bind(this))
		}
		this.data.operator = this.setOperator.gather().operator
		return this.data
	},

	test: function() {
		let data = this.gather()
		return !!data.anyValue == false && data.values.length == 0 ? i18n.get('report.filter.principal.required') : null
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.principalsPanel, this.setOperator], 'remove')
	}
})

export default PrincipalFilter

PrincipalFilter.__filename__ = 'reports/common/filter/principal-filter.js'
